import { FC } from 'react';

import withSchema from 'ia-react-core/~/hocs/schema/withSchema';
import { CollapseState } from 'ia-react-core/~/interfaces/CollapseState';
import { ParametersExceptFirst } from 'ia-react-core/~/interfaces/ParametersExceptFirst';
import { ActionMap } from 'ia-react-core/~/interfaces/ReducerActions';

import closeCollapseById from '../../../actions/collapse-fn/closeCollapseById';
import openCollapseById from '../../../actions/collapse-fn/openCollapseById';
import injectAnalyticsScope from '../../../hocs/analytics/injectAnalyticsScope';
import withUniqueId from '../../../hocs/helpers/#withUniqueId';
import injectReducer from '../../../hocs/redux/injectReducer';
import compose from '../../../utils/components/#compose';

import Collapsable, { CollapsableComposedProps, CollapsableProps, CollapsableStatics } from './Collapsable';
import collapsableReducer from './Collapsable.reducer';

const ComposedCollapsable = compose<FC<CollapsableProps> & CollapsableStatics>(
  withUniqueId('collapseId'),
  withSchema('collapse', { skip: ({ isOpened }) => typeof isOpened !== 'undefined' }),
  injectAnalyticsScope<CollapsableComposedProps>({
    key: ({ name }) => name,
  }),
  injectReducer<CollapsableComposedProps, CollapseState>({
    key: ({ name }) => name,
    idName: 'collapseId',
    namespace: 'Core/Collapse',
    skip: ({ isOpened }) => typeof isOpened !== 'undefined',
    identifiers: ({ collapseId, name }) => ({ collapseId, name }),
    reducer: collapsableReducer,
    actions: ({ collapseId: currentCollapseId }) => ({
      openCollapse: (...args: ParametersExceptFirst<typeof openCollapseById>) => openCollapseById(currentCollapseId, ...args),
      closeCollapse: (...args: ParametersExceptFirst<typeof closeCollapseById>) => closeCollapseById(currentCollapseId, ...args),
    } as ActionMap<'collapseId'>),
    initialState: ({ collapseId, name, initialIsOpened }) => ({
      collapseId,
      name,
      isOpened: Boolean(initialIsOpened),
    }),
    useScope: true,
    createScope: false,
    cleanState: true,
  }),

)(Collapsable);

ComposedCollapsable.displayName = 'Collapsable';

export * from './Collapsable';
export default ComposedCollapsable;
